<template>
  <svg width="49" height="43" viewBox="0 0 49 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_50)">
      <path
        d="M37.031 0.134007C33.6406 0.134007 29.8534 1.55925 26.0792 4.25419C25.609 4.58986 25.0421 4.76891 24.4611 4.76521C23.8802 4.76152 23.3157 4.57527 22.8499 4.23365C19.0787 1.46339 15.2776 0 11.8594 0C6.01611 0 1.60459 4.05072 0.345855 10.5724C-1.67845 20.954 5.01091 34.8317 24.4745 42.5536C38.5582 36.8321 51.4079 24.7885 48.6141 10.5919C47.2877 4.1417 42.8474 0.134992 37.031 0.134992V0.134007Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_50">
        <rect width="49" height="42.5526" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'FakeProfileHeartIcon',
};
</script>
